var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElasticsearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "elastic-search",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0BF1A",
    d: "M22.74 4.68a5.692 5.692 0 0 1-4.38 2.07H2.42C4.37 2.76 8.47 0 13.22 0c3.88 0 7.32 1.84 9.52 4.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3EBEB0",
    d: "M22.78 19.27c-2.2 2.87-5.66 4.73-9.56 4.73-4.75 0-8.85-2.76-10.8-6.75h16.01c1.75 0 3.31.78 4.35 2.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#07A5DE",
    d: "M20.38 12c0 1.88-1.54 3.38-3.37 3.38H1.71c-.32-1.07-.49-2.2-.49-3.38s.17-2.31.49-3.38h15.3c1.87 0 3.37 1.5 3.37 3.38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M12.13 12c0 1.24-.15 2.36-.41 3.38H1.71c-.32-1.07-.49-2.2-.49-3.38s.17-2.31.49-3.38h10.01c.26 1.02.41 2.14.41 3.38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7A229",
    d: "M7.182 1.613A12.35 12.35 0 0 0 2.42 6.75h8.85c-.9-2.062-2.325-3.788-4.088-5.137z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#019B8F",
    d: "M7.557 22.575a13.373 13.373 0 0 0 3.975-5.325H2.42a12.358 12.358 0 0 0 5.137 5.325z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticsearch);
export default __webpack_public_path__ + "static/media/elasticsearch.ace2006b92ac018eca64708f53dc5d4d.svg";
export { ForwardRef as ReactComponent };